import { render, staticRenderFns } from "./index.vue?vue&type=template&id=629a68af&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629a68af')) {
      api.createRecord('629a68af', component.options)
    } else {
      api.reload('629a68af', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=629a68af&", function () {
      api.rerender('629a68af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/easycard/index.vue"
export default component.exports